import type { RouteObject } from 'react-router-dom';
import { PermissionRoute } from '@/features/auth';
import { MotHistoryLookupPage } from '../components/MotHistoryLookupPage';

export const motHistoryRoutes: RouteObject[] = [
  {
    path: 'vehicles',
    children: [
      {
        element: <PermissionRoute requiredPermissions={[{ resource: 'vehicle', action: 'browse' }]} />,
        children: [{ path: 'mot-history', element: <MotHistoryLookupPage /> }],
      },
    ],
  },
];
